<template>
  <div class="w-full h-full relative">
    <PasswordReset />
    <div class="w-full absolute bottom-0 left-0 opacity-5 pointer-events-none">
      <ColorImg class="bg-current" src="images/backgrounds/register.webp" alt="" />
    </div>
    <div
      class="w-full h-full flex flex-col items-center justify-between relative overflow-auto py-8"
    >
      <div></div>
      <div class="w-[85%] md:max-w-[420px]">
        <div class="text-center">
          <div class="text-4xl font-bold whitespace-nowrap title-color">
            <slot name="title"></slot>
          </div>
          <div class="py-1"></div>
          <div class="font-bold whitespace-nowrap description-color">
            <slot name="subTitle"></slot>
          </div>
          <div class="py-3"></div>
        </div>

        <slot></slot>
        <div class="text-center pt-8">
          <span>
            <slot name="redirectQuestion"></slot>
          </span>
          &nbsp;
          <span class="text-primary-400 font-bold">
            <slot name="redirectLink"></slot>
          </span>
        </div>
        <div class="text-center pt-4">
          <span class="text-center text-primary-400 font-bold">
            <slot name="aditionnalAction"></slot>
          </span>
        </div>
      </div>
      <div class="flex justify-center py-6">
        <div class="top-0 text-3xl font-bold relative">
          <div
            class="w-8 top-0 right-0 absolute translate-x-2/3 -translate-y-1/2"
          >
            <ColorImg
              src="/images/crown.svg"
              class="w-full bg-current"
              alt=""
            />
          </div>
          <div>King Recharge</div>
        </div>
      </div>
    </div>
  </div>
</template>
